import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const securityFeatures = [
  {
    icon: 'Shield',
    title: 'Enterprise Security',
    description: 'Bank-level encryption and security protocols'
  },
  {
    icon: 'Lock',
    title: 'Data Protection',
    description: 'GDPR compliant with secure data handling'
  },
  {
    icon: 'CheckCircle',
    title: 'Verified Platform',
    description: 'Trusted by 500+ publishing professionals'
  }];


  const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'PR Director at Beacon Publishing',
    avatar: "https://images.unsplash.com/photo-1637562772116-e01cda44fce8",
    avatarAlt: 'Professional headshot of woman with shoulder-length brown hair in navy blazer',
    quote: 'PenGame PR Hub transformed our book launch campaigns. We increased media coverage by 300% in just three months.',
    rating: 5
  },
  {
    id: 2,
    name: 'Marcus Chen',
    role: 'Marketing Manager at Literary Works Inc.',
    avatar: "https://images.unsplash.com/photo-1687256457585-3608dfa736c5",
    avatarAlt: 'Professional headshot of Asian man with short black hair in gray suit',
    quote: 'The AI content creation tools save us hours every week. Our press releases are more engaging than ever.',
    rating: 5
  },
  {
    id: 3,
    name: 'Jennifer Rodriguez',
    role: 'Independent Author & Publisher',
    avatar: "https://images.unsplash.com/photo-1719515862094-c6e9354ee7f8",
    avatarAlt: 'Professional headshot of Hispanic woman with long dark hair in white blouse',
    quote: 'As a solo author, this platform gives me the PR power of a full marketing team. Absolutely game-changing.',
    rating: 5
  }];


  const industryLogos = [
  {
    name: 'Publishers Weekly',
    logo: 'https://via.placeholder.com/120x40/E5E7EB/6B7280?text=PW',
    logoAlt: 'Publishers Weekly magazine logo in gray'
  },
  {
    name: 'BookBub',
    logo: 'https://via.placeholder.com/120x40/E5E7EB/6B7280?text=BookBub',
    logoAlt: 'BookBub promotional platform logo in gray'
  },
  {
    name: 'Kirkus Reviews',
    logo: 'https://via.placeholder.com/120x40/E5E7EB/6B7280?text=Kirkus',
    logoAlt: 'Kirkus Reviews literary magazine logo in gray'
  },
  {
    name: 'Library Journal',
    logo: 'https://via.placeholder.com/120x40/E5E7EB/6B7280?text=LJ',
    logoAlt: 'Library Journal publication logo in gray'
  }];


  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground">Enterprise-Grade Security</h3>
        <div className="space-y-3">
          {securityFeatures?.map((feature, index) =>
          <div key={index} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
                <Icon name={feature?.icon} size={16} className="text-success" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground">{feature?.description}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Industry Recognition */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground">Trusted by Industry Leaders</h3>
        <div className="grid grid-cols-2 gap-3">
          {industryLogos?.map((company, index) =>
          <div key={index} className="flex items-center justify-center p-3 bg-muted rounded-md">
              <Image
              src={company?.logo}
              alt={company?.logoAlt}
              className="h-6 opacity-60" />

            </div>
          )}
        </div>
      </div>
      {/* Testimonials */}
      <div className="space-y-4">
        <h3 className="text-lg font-semibold text-foreground">What Our Users Say</h3>
        <div className="space-y-4">
          {testimonials?.map((testimonial) =>
          <div key={testimonial?.id} className="p-4 bg-card border border-border rounded-lg">
              <div className="flex items-start space-x-3">
                <Image
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-10 h-10 rounded-full object-cover" />

                <div className="flex-1 min-w-0">
                  <div className="flex items-center space-x-2 mb-1">
                    <h4 className="text-sm font-medium text-foreground">{testimonial?.name}</h4>
                    <div className="flex items-center">
                      {[...Array(testimonial?.rating)]?.map((_, i) =>
                    <Icon key={i} name="Star" size={12} className="text-warning fill-current" />
                    )}
                    </div>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2">{testimonial?.role}</p>
                  <p className="text-sm text-foreground italic">"{testimonial?.quote}"</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* SSL Certificate Badge */}
      <div className="flex items-center justify-center space-x-2 p-3 bg-success/5 border border-success/20 rounded-md">
        <Icon name="Shield" size={16} className="text-success" />
        <span className="text-sm font-medium text-success">SSL Secured</span>
        <Icon name="Lock" size={14} className="text-success" />
      </div>
    </div>);

};

export default TrustSignals;